var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.grid && _vm.grid.length > 0)?_c('div',[_c('v-container',{staticClass:"calculation-output",attrs:{"no-gutters":""}},_vm._l((_vm.grid),function(row,rowIndex){return _c('v-row',{key:rowIndex,attrs:{"dense":""}},_vm._l((row),function(cell,columnIndex){return _c('v-col',{key:columnIndex},[(
						columnIndex !== 1 || !_vm.hideBuyPrice || rowIndex === 0
					)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.outputTemplate(cell))}}):_vm._e()])}),1)}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }